import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl, UntypedFormControl } from '@angular/forms';
import { NoteService } from '../../../../../swaggerServices/api/api';
import { ITaxReturn } from '../../../../app/tax-returns/tax-return/model/i-tax-return';
import { Observable, Subscription } from 'rxjs';
import { TaxReturnStatus } from '../../../../app/tax-returns/tax-return/model/status';
import { ConfigStateService } from '../../../../app/config/config-state.service';
import { TenantConfigService } from '../../../services/tenant-config.service';
import { TranslocoService} from "@jsverse/transloco";

@Component({
    selector: 'change-reason',
    templateUrl: './change-reason.component.html',
    styleUrls: ['./change-reason.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ChangeReasonComponent implements OnInit {
  @Input() taxReturn: ITaxReturn;
  @Input() actionType: string;
  @Input() showChangeCount: boolean = false;
  @Output() cancel = new EventEmitter();
  @Output() completed = new EventEmitter();

  form: UntypedFormGroup;
  selectedSource: string;
  sourceList = [];
  subscriptions: Subscription[] = [];
  uiConfig: TenantConfigService;
  taxReturnAlias: string;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private config: ConfigStateService,
    private noteService: NoteService,
    private translocoService: TranslocoService
    ) { }

  get source(): AbstractControl {
    return this.form.get('source');
  }

  get reason(): AbstractControl {
    return this.form.get('reason');
  }


  ngOnInit() {
    this.setSourceList();
    this.initForm();
    this.subscriptions.push(
      this.config.loadConfig().subscribe(config => {
        this.uiConfig = new TenantConfigService(config);
        this.taxReturnAlias = this.uiConfig.config.taxReturnAlias
        this.translocoService.selectTranslate('tax-return-alias').subscribe(value => this.taxReturnAlias = value);
      })
    );
  }

  submitReason() {
    this.addNote().subscribe(() => {
      if (this.showChangeCount) {
        this.completed.emit({ changeCount: this.form.get('changeCount').value });
      } else {
        this.completed.emit();
      }
    });
  }

  formatter(option) {
    return option.label;
  }

  setSourceList() {
    const employerAwaitingStatus = [
      TaxReturnStatus.AWAITING_EMPLOYER_APPROVAL.id,
      TaxReturnStatus.AMENDMENT_AWAITING_EMPLOYER_APPROVAL.id,
      TaxReturnStatus.REVISION_AWAITING_EMPLOYER_APPROVAL.id,
      TaxReturnStatus.TAXPAYER_APPROVED_EMPLOYER_FAILED.id,
      TaxReturnStatus.AMENDMENT_TAXPAYER_APPROVED_EMPLOYER_FAILED.id,
      TaxReturnStatus.REVISION_TAXPAYER_APPROVED_EMPLOYER_FAILED.id
    ];
    const taxpayerAwaitingStatus = [
      TaxReturnStatus.AWAITING_TAXPAYER_APPROVAL.id,
      TaxReturnStatus.AMENDMENT_AWAITING_TAXPAYER_APPROVAL.id,
      TaxReturnStatus.REVISION_AWAITING_TAXPAYER_APPROVAL.id
    ];
    if (taxpayerAwaitingStatus.includes(this.taxReturn.status)) {
      this.sourceList = [
        { value: 'kpmg', label: 'KPMG' },
        { value: 'assignee', label: 'Assignee' }
      ];
    } else if (employerAwaitingStatus.includes(this.taxReturn.status)) {
      this.sourceList = [
        { value: 'kpmg', label: 'KPMG' },
        { value: 'employer', label: 'Employer' }
      ];
    } else {
      this.sourceList = [
        { value: 'kpmg', label: 'KPMG' },
        { value: 'employer', label: 'Employer' },
        { value: 'assignee', label: 'Assignee' },
        { value: 'employer-n-assignee', label: 'Both Employer & Assignee' }
      ];

    }
  }

  private initForm() {
    this.form = this.formBuilder.group({
      source: ['', Validators.required],
      reason: ['', Validators.required]
    });

    if (this.showChangeCount) {
      const changeCount = this.actionType === 'amend' ? this.taxReturn.amendmentCount + 1 : this.taxReturn.revisionCount + 1;

      this.form.addControl(
        'changeCount',
        new UntypedFormControl(changeCount,
          [Validators.required, Validators.pattern('^[1-9][0-9]*$')]))
    }
  }

  private addNote(): Observable<any> {
    const titleCaseActionName = this.actionType.charAt(0).toUpperCase() + this.actionType.slice(1)
    const req = {
      id: null,
      title: `${titleCaseActionName} ${this.taxReturnAlias} for ${this.taxReturn.firstName} ${this.taxReturn.lastName} - #${this.taxReturn.id}`,
      body: `Requested by: ${this.source.value.label} | Reason: ${this.reason.value}`,
      endYear: this.taxReturn.year,
      startYear: this.taxReturn.year,
      assigneeId: this.taxReturn.assigneeId,
      populationId: null,
      subcategoryIds: null,
      status: 0
    };

    return this.noteService.addNote(req);
  }


}
